import type { ReactNode } from 'react';

/** Unified bordered action panel — buy-again, receipt download, etc. */
export function AccountOrderActionSection(props: {
  readonly title: string;
  readonly children: ReactNode;
  readonly testId?: string;
}): JSX.Element {
  const { title, children, testId } = props;
  return (
    <div
      className="flex min-w-0 flex-1 flex-col gap-3 rounded-md border border-[var(--color-border)] p-3"
      data-testid={testId}
    >
      <h3 className="m-0 text-sm font-medium text-[var(--color-on-surface)]">{title}</h3>
      <div className="flex flex-col gap-2">{children}</div>
    </div>
  );
}
